<template>
  <div
    v-if="!isContainUnavailableArea"
    class="yhc-ef-total-price-display"
  >
    <div class="yhc-ef-total-price-display--inner bold">
      <p class="estimatePriceLabel">
        お見積 合計金額 (税込):
        <span
          v-if="totalPriceComputed"
          class="yhc-ef-total-price-display--inner--total-price"
        >
          ¥{{ formattedTotalPrice }}
        </span>
        <span
          v-else
          class="yhc-ef-total-price-display--inner--total-price-cannotcalc"
          >-</span
        >
        円
      </p>
      <a
        href="https://form.008008.jp/mitumori/PKZI0150Action_doInit.action"
        class="rakuraku-kazai-apply-link"
        target="_blank"
        rel="noopener"
        @click="sendGA4EventForMoveWebApplication"
        >Webお申込みフォームへ >></a
      >
    </div>
    <div class="yhc-ef-total-price-display--notice">
      ※入力いただいた情報は申込みフォームへは引き継がれませんので予めご了承ください。
    </div>
  </div>
</template>

<script lang="ts">
import { YhcEstimateFormFrontService } from '../../YhcEstimateFormFrontService'
import { $yhcGA4EventSender } from '../../YhcGA4EventSender'
import { computed, inject, ref, watch } from 'vue'

/**
 * # お見積り合計金額表示 コンポーネント
 * - 基本 画面下部固定の Component
 *
 * ## 責任範囲
 * - 合計金額の表示
 * - 合計金額補足情報の表示 (例: +クレーン利用料 現地見積 など)
 *
 */
export default {
  name: 'YhcEFTotalPriceDisplay',
  setup() {
    const YhcEstimateFormFrontServiceInstance = inject(
      'YhcEstimateFormFrontServiceInstance',
    ) as YhcEstimateFormFrontService
    const totalPriceComputed = ref(
      YhcEstimateFormFrontServiceInstance.$userInputData.totalPrice,
    )

    watch(
      () => YhcEstimateFormFrontServiceInstance.$userInputData.totalPrice,
      (newValue) => {
        totalPriceComputed.value = newValue
      },
    )

    const formattedTotalPrice = computed(() => {
      return totalPriceComputed.value ? totalPriceComputed.value.toLocaleString() : ''
    })

    const isContainUnavailableArea = computed(
      () => YhcEstimateFormFrontServiceInstance.$userInputData.isContainUnavailableArea,
    )

    const sendGA4EventForMoveWebApplication = () => {
      $yhcGA4EventSender.moveWebApplicationPage()
    }

    return {
      totalPriceComputed,
      formattedTotalPrice,
      isContainUnavailableArea,
      sendGA4EventForMoveWebApplication,
    }
  },
}
</script>

<style lang="scss">
.yhc-ef-total-price-display {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: var(--yhc-color);
  color: white;
  padding: var(--yhc-base-pad);
  z-index: 1040;
  box-shadow: 0px -4px 4px rgba(0, 0, 0, 0.25);

  @media screen and (max-width: 757px) {
    padding: var(--yhc-base-pad-sm);
  }
  .yhc-ef-total-price-display--inner {
    text-align: right;
    .yhc-ef-total-price-display--inner--total-price {
      margin-left: var(--yhc-base-pad-sm);
    }

    .estimatePriceLabel {
      display: inline;

      @media screen and (max-width: 757px) {
        display: block;
        text-align: center;
        margin-bottom: 8px;
        font-size: 14px;
      }
      .yhc-ef-total-price-display--inner--total-price,
      .yhc-ef-total-price-display--inner--total-price-cannotcalc {
        font-size: 2rem;
        min-width: 70px;
        display: inline-block;
        text-align: center;

        @media screen and (max-width: 757px) {
          font-size: 20px;
        }
      }
    }

    .rakuraku-kazai-apply-link {
      color: white;
      margin-left: var(--yhc-base-pad);
    }
    a {
      font-weight: normal;
    }
  }
  .yhc-ef-total-price-display--notice {
    text-align: right;
    font-size: 12px;
  }
}
</style>
